const EcoCartClose: React.FC = () => (
    <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path id="Vector 1" d="M1 1L21 21" stroke="currentColor" />
            <path id="Vector 2" d="M21 1L1 21" stroke="currentColor" />
        </g>
    </svg>
);

export default EcoCartClose;
